import { ApiNetWork } from "@/network/apiNet/apiNet";


// 赛程接口
export function getMatchv6(data) {
  return ApiNetWork.get("app/encryptionMatchNew6",data);
}